// extracted by mini-css-extract-plugin
export default {"wrapper":"emptyContent_wrapper__OyeFY","empty_text":"emptyContent_empty_text__uZrVl"};